module.exports = "/fonts/RistrettoPro-Regular.svg";